import { Injectable } from '../../helpers';

export class CameraService extends Injectable {

    static get $inject() {
        return [
            '$window',
        ];
    }

    access(params) {

        const n = this.$window.navigator;
        n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);

        return n.mediaDevices
            .getUserMedia({video: params});
    }
}


// WEBPACK FOOTER //
// ./src/app/services/camera-service.js